import { useQuery } from 'react-query'
import { getRisikaUsers } from 'services/cm-api/get-risika-users'

export function useRisikaUsers() {
  return useQuery(['getRisikaUsers'], getRisikaUsers, {
    enabled: Boolean(localStorage.getItem('FB_ACCESS_TOKEN')),
  })
}
